/**
 * iter87.188 — Section info dot (the little `?` next to a section header).
 *
 * A tiny 20×20 button that opens a radix Popover with a 2-3-sentence
 * explainer for that section. Reused on the four main section headers:
 * "Start a Rivalry", "Your Rivalries", "Rivalries You Play In",
 * "Archived Rivalries". Portal-rendered by radix so opening it never
 * shifts sibling elements on the row.
 *
 * iOS Safari safe: `touch-manipulation` on the trigger kills the 300ms
 * tap delay; no `backdrop-filter`; solid `#0f0f10` popover background.
 */
import * as React from "react";
import { HelpCircle } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "../components/ui/popover";

export default function SectionInfoDot({ label, body, testid }) {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <button
                    type="button"
                    data-testid={testid}
                    aria-label={`What is ${label}?`}
                    className="inline-flex items-center justify-center w-5 h-5 rounded-full text-zinc-500 hover:text-cyber transition-colors touch-manipulation align-middle"
                >
                    <HelpCircle className="w-4 h-4" />
                </button>
            </PopoverTrigger>
            <PopoverContent
                data-testid={`${testid}-popover`}
                align="start"
                side="bottom"
                sideOffset={6}
                collisionPadding={12}
                className="w-[260px] sm:w-[300px] p-3 rounded-lg border border-zinc-700 bg-[#0f0f10] text-white shadow-2xl"
            >
                <p className="font-display font-black text-xs uppercase tracking-tight text-cyber">
                    {label}
                </p>
                <p className="text-xs text-zinc-300 mt-1.5 leading-relaxed">{body}</p>
            </PopoverContent>
        </Popover>
    );
}
